import React, { useEffect, useState } from 'react'
import PageHead from '../../Components/PageHead'
import Tab from '../../Components/Tab';
import { LogInUserID, typewatch } from '../../JS/Common';
import { ApiGetCall } from '../../JS/Connector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightToBracket } from '@fortawesome/free-solid-svg-icons';
import useConfig from '../../Hooks/useConfig';

function RocketCustomers() {
    const { secondary_text, organization } = useConfig();
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [Alerts, setAlerts] = useState("");
    const [tabs, setTabs] = useState({
        VAR: "active",
        MSP: "",
    });
    const [GridData, setGridData] = useState([])
    const [Searchstring, setSearchstring] = useState(null)
    const [SortbyFlag, setSortbyFlag] = useState('asc')
    const [SortbyKey, setSortbyKey] = useState(null)
    const [selectUserData, setSelectUserData] = useState([])
    const [openNoteId, setOpenNoteId] = useState(null);

    useEffect(() => {
        getAllData(SortbyKey, Searchstring, SortbyFlag);
    }, [currentPage, LimitForPagination, tabs]);

    async function getAllData(sortbykey, search, sortbyflag) {
        if (!search) search = null;
        var tabflag = null;
        tabs?.VAR == "active" ? tabflag = 1 : tabflag = 2;
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall("/AllVarUsers").then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setGridData(responseRs?.msg)
                    setLoading(false);
                }
            });
        }, search != null ? 500 : 0);
    }

    async function getSelectedData(id) {
        await ApiGetCall("/varUserDetailByID/" + id).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setSelectUserData(responseRs?.msg)
            }
        });
    }

    function handleSearchChange(e) {
        setCurrentPage(1);
        setSearchstring((prevSearchstring) => {
            const newSearchstring = e.target.value;
            getAllData(SortbyKey, newSearchstring, SortbyFlag);
            return newSearchstring;
        });
    }

    function handleTabClick(tabType) {
        if (tabType == "VAR") {
            setCurrentPage(1);
            setTabs({ ...tabs, VAR: "active", MSP: "" });
        } else if (tabType == "MSP") {
            setCurrentPage(1);
            setTabs({ ...tabs, VAR: "", MSP: "active" });
        }
    }
    const handleSortClick = (item) => {
        // if (item !== 0) {
        //     if (tabs.VAR == "active") {
        //         GetData(1, AllData.searchstringForRefund, item, true)
        //     } else {
        //         GetData(2, AllData.searchstringForCoverage, item, true)
        //     }
        //     setSortbyKey(item)
        // }
    };
    function handleArrowClick(ticketId) {
        setOpenNoteId((prevId) => (prevId === ticketId ? null : ticketId));
    }
    return (
        <div>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={`${secondary_text} Customers`} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />

            <div className="GridBox mt-2 p-3">
                <div className="row">
                    <div className="col-md-9 pe-0 pb-3">
                        <ul className="nav nav-tabs">
                            <Tab isActive={tabs.VAR == 'active'}
                                label="VAR Customers" onClick={() => handleTabClick('VAR')} col={'col-md-3'} />
                            <Tab isActive={tabs.MSP == 'active'}
                                label={"MSP Customers"} onClick={() => handleTabClick('MSP')} col={'col-md-3'} />
                        </ul>
                    </div>
                </div>
                <div className="greyBox p-3 data-table-container">
                    <table className="table data-table">
                        <thead className='GridHeader'>
                            <tr>
                                <th scope="col" className='cursor-pointer fw-600' title={`Sort by User Name`} onClick={(e) => handleSortClick('student_num')}>
                                    User Name
                                </th>
                                <th scope="col" className='fw-600'>
                                    Email
                                </th>
                                <th scope="col" className='fw-600'>
                                    Company Name
                                </th>
                                <th scope="col"> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {GridData?.length !== 0 ? (
                                GridData.map((item, i) => {
                                    const isNoteVisible = openNoteId == item.id;
                                    return (
                                        <React.Fragment key={i}>
                                            <tr className="OddEvenClass tableBorderHide">
                                                <td className="py-12">{item.name}</td>
                                                <td className="py-12">{item.email}</td>
                                                <td className="py-12">{item.comapny_name}</td>
                                                <td className="py-12">
                                                    <img
                                                        src="/images/DownRoundArrow.svg"
                                                        id={`DownArrow_${item.id}`}
                                                        className={`cursor-pointer img-fluid ${isNoteVisible ? 'd-none' : ''}`}
                                                        onClick={() => { handleArrowClick(item.id); getSelectedData(item.id) }}
                                                    />
                                                    <img
                                                        src="/images/UpRoundArrow.svg"
                                                        id={`UpArrow_${item.id}`}
                                                        className={`cursor-pointer img-fluid ${isNoteVisible ? '' : 'd-none'}`}
                                                        onClick={() => { handleArrowClick(item.id); }}
                                                    />
                                                </td>
                                            </tr>

                                            {isNoteVisible && (
                                                <tr className="col-12 px-3">
                                                    <td colSpan={18}>
                                                        <table className="table data-table">
                                                            <thead className='GridHeader'>
                                                                <tr>
                                                                    <th scope="col" className='fw-600'>  {organization} Name </th>
                                                                    <th scope="col" className='fw-600'>  Location</th>
                                                                    <th scope="col" className='fw-600'>  Total Ticket</th>
                                                                    <th scope="col" className='fw-600'>  Close Tickets</th>
                                                                    <th scope="col" className='fw-600'> Contact Email</th>
                                                                    <th scope="col" className='fw-600'> Contact Name</th>
                                                                    <th scope="col" className='fw-600'> Open Ticket</th>
                                                                    <th scope="col" className='fw-600'> </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {selectUserData?.length !== 0 ? (
                                                                    selectUserData.map((sitem, index) => {
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <tr className="tableBorderHide">
                                                                                    <td className="py-12">{sitem.name}</td>
                                                                                    <td className="py-12">{sitem?.location?.name}</td>
                                                                                    <td className="py-12">{sitem.all_ticket_count || 0}</td>
                                                                                    <td className="py-12">{sitem.closed_ticket_count || 0}</td>
                                                                                    <td className="py-12">{sitem.oldestUser?.email || '-'}</td>
                                                                                    <td className="py-12">{sitem.oldestUser?.first_name + ' ' + sitem.oldestUser?.last_name || "-"}</td>
                                                                                    <td className="py-12">{sitem.open_ticket_count || 0}</td>
                                                                                    <td className="py-12">
                                                                                        <FontAwesomeIcon icon={faArrowRightToBracket} style={{ color: "black" }}
                                                                                            title={`Login as ${organization} Admin`} className='parent-icon cursor-pointer '
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            </React.Fragment>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    <tr className="text-center">
                                                                        <td colSpan={15}>No Record Found</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <tr className="text-center">
                                    <td colSpan={15}>No Record Found</td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
    )
}

export default RocketCustomers
